/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-14 13:57:22
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2022-07-20 11:06:06

 * @Description: form组件入口
 * @FilePath: /hsylc2021/src/components/form/index.js
 */
export { default as Button } from './Button';
export { default as Input } from './Input';
export { default as Select } from './Select/select.vue';
export { default as Textarea } from './Textarea';
export { default as TextareaPrototype } from './Textarea/Prototype.vue';
export { default as Radio } from './Radio';
export { default as RadioSlot } from './Radio/Slot';
export { default as RadioGroup } from './RadioGroup';
export { default as RadioGroupSingle } from './RadioGroup/Single';
export { default as RadioGroupPropotype } from './RadioGroup/Prototype.vue';
export { default as Checkbox } from './Checkbox';
export { default as CheckboxSlot } from './Checkbox/Slot';
export { default as CheckboxGroup } from './CheckboxGroup';
export { default as CheckboxGroupPrototype } from './CheckboxGroup/Prototype.vue';
export { default as RadioTrigger } from './RadioTrigger';
export { default as VerificationMsg } from './VerificationMsg/verificationMsg';
export { default as AreaCodeSelect } from './AreaCodeSelect/areaCodeSelect';
export { default as SchoolSelect } from './SchoolSelect/schoolSelect';
export { default as SelectDefault } from './Select/default.vue';
export { default as SelectArea } from './SchoolSelect/Area.vue';
export { default as Country } from './Country';
export { default as CardType } from './CardType';
export { default as Rich } from './Rich';
export { default as CheckInput } from './CheckInput/checkInput.vue';
export { default as DatePicker } from './DatePicker/datePicker';
export { default as FileUploader } from './Uploader/FileUploader';
export { default as ImageUploader } from './Uploader/ImageUploader';
export { default as AvatarUploader } from './Uploader/Avatar';
export { default as ChoiceVolunteerBtn } from './ChoiceVolunteerBtn/choiceVolunteerBtn';
export { default as FilterSelect } from './FilterSelect';
export { default as GenderSelect } from './GenderSelect';
export { default as GenderSelectCH } from './GenderSelect/Chinese';
export { default as TimeZoneSelect } from './TimeZoneSelect';
export { default as ButtonSelector } from './ButtonSelector';
export { default as Trigger } from './Trigger';
